module.exports = __webpack_public_path__ + "img/success_4.894adf5a.gif";